var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSmileWink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M12 1C5.923 1 1 5.923 1 12s4.923 11 11 11 11-4.923 11-11S18.077 1 12 1zm0 19.871c-4.892 0-8.871-3.979-8.871-8.871S7.108 3.129 12 3.129 20.871 7.108 20.871 12 16.892 20.871 12 20.871zm5.225-6.494a1.064 1.064 0 00-1.5.138A4.836 4.836 0 0112 16.262a4.827 4.827 0 01-3.726-1.747 1.067 1.067 0 00-1.499-.138 1.07 1.07 0 00-.138 1.5A6.966 6.966 0 0012 18.387a6.966 6.966 0 005.363-2.51 1.065 1.065 0 00-.138-1.5zM8.452 11.29c.785 0 1.419-.634 1.419-1.419a1.418 1.418 0 10-2.839 0c0 .785.635 1.42 1.42 1.42zm7.096-2.661c-1.14 0-2.479.75-2.656 1.867a.532.532 0 00.878.48l.421-.378c.657-.585 2.05-.585 2.706 0l.421.377c.377.329.958.014.878-.479-.168-1.117-1.508-1.867-2.648-1.867z"
  }))));
}

export default SvgSmileWink;